import React, { useEffect } from 'react';
import ProductCard from './ProductCard';

const ProductSkeleton = () => (
  <div className="animate-pulse">
    <div className="aspect-square bg-stone-200 rounded-2xl mb-4" />
    <div className="h-3 bg-stone-200 rounded w-1/3 mb-2" />
    <div className="h-5 bg-stone-200 rounded w-3/4 mb-2" />
    <div className="h-3 bg-stone-200 rounded w-full mb-3" />
    <div className="h-6 bg-stone-200 rounded w-1/4" />
  </div>
);

const ProductSection = ({ 
  id, 
  title, 
  tagline, 
  description, 
  products, 
  accentColor = '#8B7355',
  onAddToCart,
  onProductClick,
  loading = false
}) => {
  return (
    <section id={id} className="py-24 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl mb-16">
          <div 
            className="inline-block w-12 h-1 rounded-full mb-6"
            style={{ backgroundColor: accentColor }}
          />
          <h2 className="text-4xl md:text-5xl font-serif text-stone-800 mb-4">
            {title}
          </h2>
          <p 
            className="text-lg font-medium mb-3"
            style={{ color: accentColor }}
          >
            {tagline}
          </p>
          <p className="text-stone-500 leading-relaxed">
            {description}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {loading ? (
            // Show skeleton loaders
            Array.from({ length: 3 }).map((_, index) => (
              <ProductSkeleton key={index} />
            ))
          ) : products.length > 0 ? (
            products.map((product) => (
              <ProductCard 
                key={product.id} 
                product={product} 
                onAddToCart={onAddToCart}
                onProductClick={onProductClick}
              />
            ))
          ) : (
            <p className="col-span-full text-center text-stone-500 py-8">
              No products available in this collection.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
